export interface CapacitorNativeGoogleAuthPlugin {
  signIn(): Promise<{ idToken: string }>;
}
